module.exports = "/work-site/img/logo.2704eabc.png";